export default {
  Email: 'E-posta',
  ConfirmEmail: 'E-postayı Onayla',
  Password: 'Şifre',
  Verificationcode: 'Doğrulama kodu',
  AlreadyhaveaHitPawaccountLogin:
    'Zaten bir HitPaw hesabınız var mı? Giriş yap',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
    'Kaydolarak, Kullanım Hizmetlerimizi ve Gizlilik Politikamızı kabul etmiş olursunuz',
  ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
    'Devam ederek, Kullanım Hizmetlerimizi ve Gizlilik Politikamızı kabul etmiş olursunuz.',
  Byproceedingyouagreetoour: 'Devam ederek, ',
  ServicesofUse: 'Kullanım Hizmetlerimizi',
  and: ' ve ',
  PrivacyPolicy: 'Gizlilik Politikamızı',
  last: ' kabul etmiş olursunuz.',
  TheEmailformatisincorrect: 'E-posta biçimi yanlış',
  Pleaseenterthesameemailinbothfields:
    'Lütfen her iki alana da aynı e-postayı girin.',
  Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
    'Şifre 8-50 karakter arasında olmalı ve aşağıdakiler arasından en az iki kategori içermelidir: sayı, harf veya özel karakter.',
  Incorrectverificationcode: 'Doğrulama kodu yanlış',
  ThisEmailhasbeenregisteredpleasechooseanother:
    'Bu E-posta kaydedildi, lütfen başka bir e-posta seçin.',
  Cannotbeemptyhere: 'Burada boş olamaz.',
  Rememberme: 'Beni hatırla',
  ForgotPassword1: 'Şifrenizi Mi Unuttunuz?',
  NotaregistereduseryetSignUp:
    'Henüz kayıtlı bir kullanıcı değil misiniz? Kayıt Ol',
  Notaregistereduseryet1: 'Henüz kayıtlı bir kullanıcı değil misiniz? ',
  Notaregistereduseryet2: 'Kayıt Ol',
  NoaccountfoundwiththatEmailaddress:
    'Bu e-posta adresine ait bir hesap bulunamadı',
  YourEmailaddressorpasswordwasincorrectPleasetryagain:
    'E-posta adresiniz veya şifreniz yanlıştı. Lütfen tekrar deneyin.',
  ForgotPassword2: 'Şifremi Unuttum',
  GetVerificationCode: 'Doğrulama Kodu Alın',
  VerifyEmail: 'E-postayı Doğrula',
  Ithasbeensenttoyourmailboxpleasecheckit:
    'Posta kutunuza gönderildi, lütfen kontrol edin',
  PleaseinputEmailaddress: 'Lütfen E-posta adresinizi girin',
  TheEmailisnotregistered: 'E-posta kayıtlı değil',
  Invalidverificationcodepleasereenterthecorrectone:
    'Geçersiz doğrulama kodu, lütfen doğru kodu tekrar girin',
  Resetpassword: 'Şifreyi sıfırla',
  Emailaddressverificationsucceeded: 'E-posta adresi doğrulaması başarılı oldu',
  Pleaseresetyourpassword: 'Lütfen şifrenizi sıfırlayın',
  Enteranewpassword: 'Yeni bir şifre girin',
  Confirm: 'Onayla',
  Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
    'Yeni şifre 8-50 karakter uzunluğunda olmalı, harf veya rakamlardan veya harf + rakam karışımından oluşmalıdır.',
  Passwordresetsuccessfully: 'Şifre başarıyla sıfırlandı',
  Name: 'İsim',
  GetCode: 'Kodu Al',
  Loginsuccessful: 'Giriş başarılı',
  Loginfailed: 'Giriş başarısız',
  Signupsuccessful: 'Kayıt olma başarılı',
  Signupfailed: 'Kayıt olma başarısız',
  Getpassword: 'Şifre al',
  Authorizationhasexpiredpleaseloginagain:
    'Yetkilendirme süresi doldu, lütfen tekrar giriş yapın.',
  Sorrysomethingwentwrongpleasetryagainlater:
    'Üzgünüz, bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.',
  Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
    'Kısa sürede çok fazla aynı istek yapıldı, lütfen daha sonra tekrar deneyin.',
  Couldntfindyouraccountorthepasswordisincorrect:
    'Hesabınız bulunamadı veya şifre yanlış.',
  Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
    'Ücretli bir işleve erişmeye çalışıyorsunuz, lütfen önce abone olun.',
  Accessdeniedfortheunauthorizedrequest:
    'Yetkisiz istek için erişim reddedildi.',
  Alreadyhaveaccount: 'Hesap var mı?',
  SignUpwithemail: 'Iscriviti con e-mail',
  Securityverification: 'Güvenlik doğrulaması',
  Pleaseenterthecorrectemailaddress: 'Lütfen doğru e-posta adresini girin!',
  PleaseInputverificationCode: 'Lütfen doğrulama kodu girin!',
  Pleaseenterthesamepasswordinbothfields:
    'Lütfen iki alanda aynı parolanı girin!',
  or: 'Mor',
  ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
    'Girdiğiniz yeni şifre eski şifrenizle aynıdır. Farklı bir şifre girin',
  YourpasswordwasincorrectPleasetryagain:
    'Şifreniz yanlıştı. Lütfen tekrar deneyin.',
  reg400: 'Üzgünüz, bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.',
  reg400223: 'E-posta ve kod eşleşmiyor, lütfen kontrol edin',
  reg400224: ',Jetonun süresi doldu',
  500: 'Sunucu taraf hatası!',
  Afewsecondsaway: 'Birkaç saniye uzakta',
  ContinuewithGoogle: 'Google ile devam',
  ContinuewithEmail: 'E-posta ile devam et',
  LoginwithEmail: 'E-posta ile devam et',
  Usemorethan8charactersandmixlettersnumbersandsymbols:
    "Harfler, sayılar ve simgeler içeren 8'den fazla karakter kullanın (destekleyici simgeler:@$!%*#_~?&^)",
  ConfirmPassword: 'Şifreyi Onayla',
  Pleaseloginwithemail: 'Lütfen E-posta ile giriş yapın',
  youraccount: 'Hesabınız',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'zaten mevcut, hesabınızın güvenliğini sağlamak için lütfen önce doğrulamayı tamamlayın.',
  Login: 'Giriş yapmak',
  exceed6Times:
    "Deneme süreniz bugün sona erdi, tüm premium özelliklere erişmek için lütfen Pro'ya yükseltin.",
  exceed20M:
    "Ücretsiz hesaplar için dosya boyutu 20 MB'ı aşamaz, tüm premium özelliklere erişmek için lütfen Pro'ya yükseltin.",
  403102: 'Google hesabı başka bir hesaba bağlandı',
};
